import React, { useEffect, useState } from "react";
import "./Navbar.css";
import { RiMenu3Line, RiCloseLin, RiCloseLine } from "react-icons/ri";
import codeZephyr from "../../assets/code-zephyr.svg";
import Logo from "../Logo/Logo";

const Navbar = () => {
  const [toggleMenu, setToggleMenu] = useState(false);

  const [opaqueNav, setOpaqueNav] = useState(false);

  const changeNav = () => {
    if (window.scrollY >= 100) {
      setOpaqueNav(true);
    } else {
      setOpaqueNav(false);
    }
  };

  window.addEventListener("scroll", changeNav);

  // var prevScrollpos = window.pageYOffset;

  // window.onscroll = function () {
  //   var currentScrollPos = window.pageYOffset;
  //   if (prevScrollpos > currentScrollPos) {
  //     document.getElementById("navbar").style.top = "0";
  //   } else {
  //     document.getElementById("navbar").style.top = "-110px";
  //   }
  //   prevScrollpos = currentScrollPos;
  // };

  return (
    <div className={opaqueNav ? "navbar opaqueNav" : "navbar"} id="navbar">
      <div className="navbar-links">
        <div className="navbar-links_logo">
          {/* <img src={codeZephyr} alt="logo" /> */}
          <Logo />
        </div>

        <div className="navbar-links_container">
          <p>
            <a href="#home">Home</a>
          </p>
          <p>
            <a href="#about">About us</a>
          </p>
          <p>
            <a href="#promotion">Products</a>
          </p>
          <p>
            <a href="#features">Services</a>
          </p>
          <p>
            <a href="#blog">Library</a>
          </p>
        </div>
        <div className="navbar-sign">
          <p>Sign in</p>
          <button type="button">Sign up</button>
        </div>
      </div>
      <div className="navbar-menu">
        {toggleMenu ? (
          <RiCloseLine
            color="#fff"
            size={27}
            onClick={() => setToggleMenu(false)}
          />
        ) : (
          <RiMenu3Line
            color="#fff"
            size={27}
            onClick={() => setToggleMenu(true)}
          />
        )}
        {toggleMenu && (
          <div className="navbar-menu_container scale-up-center">
            <div className="navbar-menu_container-links">
              <p>
                <a href="#home">Home</a>
              </p>
              <p>
                <a href="#about">About Us</a>
              </p>
              <p>
                <a href="#promotion">Products</a>
              </p>
              <p>
                <a href="#features">Services</a>
              </p>
              <p>
                <a href="#blog">Library</a>
              </p>
            </div>
            <div className="navbar-menu_container-links-sign">
              <p>Sign in</p>
              <button type="button">Sign up</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Navbar;
